// import EventManagement from '@/features/acs/event-management'
import AcsRoutes from '@/pages/SUPPORTPAGES/AcsRoutes'
import ROUTER from '@/routes/ROUTER'
import React, { lazy } from 'react'
import { LazyLoadingComponent } from '..'
const ViolationDetail = React.lazy(() => import('@/pages/ADMIN/ViolationDetail'))
const GeneralInfoFeature = React.lazy(() => import('@/features/acs/general-info'))
const CardSwipingInfo = React.lazy(() => import('@/features/acs/card-swiping-info'))
const LeaveInfoFeature = React.lazy(() => import('@/features/acs/leave-info'))

const FineInfoFeature = React.lazy(() =>
  import('@/features/acs/fine-info').then((m) => ({ default: m.FineInfoListContainer }))
)
const ComplaintManagementPage = React.lazy(() => import('@/pages/ACS/ComplaintManagement'))
const ShiftRequestFeature = React.lazy(() => import('@/features/acs/shift-request-manager'))
// const ManageVotes = React.lazy(() => import('@/pages/ADMIN/ManageVotes/TicketPageAdmin'))
const EventManagementPage = React.lazy(() => import('@/pages/ACS/EventManagement'))
const TicketManagementPage = React.lazy(() => import('@/pages/ACS/TicketManagement'))
const EmployeeWatch = lazy(() => import('@/pages/ACS/EmployeeWatch/components/EmployeeWatch'))
const TrackingInfo = React.lazy(() => import('@/features/acs-manager/tracking-info'))
const TravelAllowanceStats = React.lazy(
  () => import('@/features/acs-manager/travel-allowance-stats')
)
const WorkShiftManagement = React.lazy(() => import('@/features/acs-manager/work-shift-management'))
const ShiftInformation = React.lazy(() => import('@/pages/ADMIN/ShiftInformation'))
const LeaveList = React.lazy(() => import('@/pages/ADMIN/LeaveList'))
// khiếu nại
// const ComplaintList = React.lazy(() => import('@/pages/ACS/ComplaintList'))

const _DutyRosterPage = React.lazy(() => import('@/pages/ACS/DutyRoster'))
const Violations = React.lazy(() => import('@/pages/ADMIN/Violations'))
const InOutInfor = React.lazy(() => import('@/pages/ADMIN/ManageEntry/components/InOutInfor'))
const EmployeeViolation = React.lazy(() => import('@/pages/ADMIN/EmployeeViolation'))
const UserAttendancePage = React.lazy(() => import('@/pages/ACS/UserAttendance'))

export const acsRoutes = [
  {
    element: (
      <LazyLoadingComponent>
        <AcsRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.NHAN_VIEN_VI_PHAM,
        element: (
          <LazyLoadingComponent>
            <EmployeeViolation />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_VI_PHAM,
        element: (
          <LazyLoadingComponent>
            <EmployeeViolation />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANH_SACH_VI_PHAM,
        element: (
          <LazyLoadingComponent>
            <Violations />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.VI_PHAM,
        element: (
          <LazyLoadingComponent>
            <ViolationDetail />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHAT_HIEN_RA_VAO,
        element: (
          <LazyLoadingComponent>
            <InOutInfor />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_CHUNG,
        element: (
          <LazyLoadingComponent>
            <GeneralInfoFeature />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_QUET_THE,
        element: (
          <LazyLoadingComponent>
            <CardSwipingInfo />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_NGHI_PHEP,
        element: (
          <LazyLoadingComponent>
            <LeaveInfoFeature />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_TIEN_PHAT,
        element: (
          <LazyLoadingComponent>
            <FineInfoFeature />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.XU_LY_KHIEU_NAI,
        element: (
          <LazyLoadingComponent>
            <ComplaintManagementPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_SU_KIEN,
        element: (
          <LazyLoadingComponent>
            <EventManagementPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_PHIEU,
        element: (
          <LazyLoadingComponent>
            <TicketManagementPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: `${ROUTER.QUAN_LY_PHIEU}/:id`,
        element: (
          <LazyLoadingComponent>
            <TicketManagementPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.GIAM_SAT_NHAN_VIEN,
        element: (
          <LazyLoadingComponent>
            <EmployeeWatch />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_THEO_DOI,
        element: (
          <LazyLoadingComponent>
            <TrackingInfo />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_CA_LAM_VIEC,
        element: (
          <LazyLoadingComponent>
            <ShiftInformation />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_CONG_TAC_PHI,
        element: (
          <LazyLoadingComponent>
            <TravelAllowanceStats />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_KE_NGHI_PHEP,
        element: (
          <LazyLoadingComponent>
            <LeaveList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_CA_LAM_VIEC,
        element: (
          <LazyLoadingComponent>
            <WorkShiftManagement />
          </LazyLoadingComponent>
        ),
      },
      // {
      //   path: ROUTER.LICH_TRUC,
      //   element: (
      //     <LazyLoadingComponent>
      //       <DutyRosterPage />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.DANG_KY_DOI_CA,
        element: (
          <LazyLoadingComponent>
            <ShiftRequestFeature />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_NHAN_VIEN_DIEM_DANH,
        element: (
          <LazyLoadingComponent>
            <UserAttendancePage />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
]
